import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './data.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService extends BaseService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super('v1/reportes/ventas', httpClient, authService);
  }

  obtenerPorMetodoPago(start: string, end: string): Observable<any[]> {
    return this.post({ start, end }, 'por-metodo-pago') as Observable<any[]>;
  }
}
